// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonUnits = {
  question: "問",
  score: "点",
  minutes: "分",
} as const;
